var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Single function that handles GA events
 * @param value if any value is not defined, then pass blank string
 * @param user_id user id. If user is already logged in, then this will automatically pick up logged in user's userid
 * @param href href to pass if there is any
 * @param position position to pass if there is any
 * @param searchtext search text to pass if there is any
 */
// export default function gtmService(
//   value: ValueInterface,
//   user_id?: string,
//   href?: string,
//   position?: string,
//   searchtext?: string
// ) {
//   if (!user_id) user_id = localStorage.getItem("accountCode");
//   let data = { ...value, user_id, href, position, searchtext };
//   console.log({ data });
//   dataLayer.push(data);
// }
var GTMServiceClass = /** @class */ (function () {
    function GTMServiceClass(localStorage) {
        this.localStorage = localStorage;
    }
    GTMServiceClass.prototype.gtmService = function (value, user_id, href, position, searchtext) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!user_id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStorage.get("accountCode")];
                    case 1:
                        user_id = _a.sent();
                        _a.label = 2;
                    case 2:
                        data = __assign(__assign({}, value), { user_id: user_id, href: href, position: position, searchtext: searchtext });
                        dataLayer.push(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    return GTMServiceClass;
}());
export { GTMServiceClass };
var ReportGAEvents = /** @class */ (function () {
    function ReportGAEvents(action, category, label) {
        this.action = action;
        this.category = category;
        this.label = label;
        this.event = "event_New_Report";
    }
    return ReportGAEvents;
}());
export { ReportGAEvents };
